import { computed } from 'vue'
import { useTokenStore } from '@/stores/token'
import { EChannel } from '@/shared/enum/channel.enum'

export const useChannels = () => {
  const tokenStore = useTokenStore()

  /**
   * @function isChatbotChannel
   * @return {boolean} is true if the token is a Chatbot channel token, or false otherwise.
   */
  const isChatbotChannel = computed((): boolean => {
    return tokenStore.decodedToken?.cc?.toLowerCase() === EChannel.CHATBOT
  })

  /**
   * @function isMCAppChannel
   * @return {boolean} is true if the token is an MCApp channel token, or false otherwise.
   */
  const isMCAppChannel = computed((): boolean => {
    return tokenStore.decodedToken?.app === EChannel.MCAPP
  })

  /**
   * @function isMCWebChannel
   * @return {boolean} is true if the token is an MCWeb channel token, or false otherwise.
   */
  const isMCWebChannel = computed((): boolean => {
    return tokenStore.decodedToken?.app === EChannel.MCWEB
  })

  return {
    isChatbotChannel,
    isMCAppChannel,
    isMCWebChannel
  }
}
